import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const designationsAdapter = createEntityAdapter({})

const initialState = designationsAdapter.getInitialState()

export const designationApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getdesignations: builder.query({
            query: () => ({
                url: '/designations',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadeddesignations = responseData.map(designation => {
                    // console.log(designation)
                    designation.id = designation._id
                    // console.log(designation)
                    return designation
                });
                return designationsAdapter.setAll(initialState, loadeddesignations)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'DESIGNATION', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'DESIGNATION', id }))
                    ]
                } else return [{ type: 'DESIGNATION', id: 'LIST' }]
            }
        }),
        addNewdesignation: builder.mutation({
            query: initialUserData => ({
                url: '/designations',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'DESIGNATION', id: "LIST" }
            ]
        }),
        addBulkdesignation: builder.mutation({
            query: initialUserData => ({
                url: '/designations/addbulk',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'DESIGNATION', id: "LIST" }
            ]
        }),
        updatedesignation: builder.mutation({
            query: initialUserData => ({
                url: '/designations',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DESIGNATION', id: arg.id }
            ]
        }),        
        deletedesignation: builder.mutation({
            query: ({ id }) => ({
                url: "/designations",
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DESIGNATION', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetdesignationsQuery,
    useAddNewdesignationMutation,
    useAddBulkdesignationMutation,
    useUpdatedesignationMutation,
    useDeletedesignationMutation, 
} = designationApiSlice

// returns the query result object
export const selectdesignationsResult = designationApiSlice.endpoints.getdesignations.select()

// creates memoized selector
const selectdesignationsData = createSelector(
    selectdesignationsResult,
    designationsResult => designationsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAlldesignations,
    selectById: selectdesignationById,
    selectIds: selectdesignationIds
    // Pass in a selector that returns the users slice of state
} = designationsAdapter.getSelectors(state => selectdesignationsData(state) ?? initialState)